// @ts-nocheck

import React from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';

import theme from '../../styled-components/dark';

const StyledButton = styled.button`
  && {
    border-radius: 1.5em;
    border: none;
    outline: none;
    padding: 0 1em;
    font-weight: 800;
    cursor: pointer;

    ${({ $isDisabled }) =>
      $isDisabled
        ? css`
            color: ${theme.PrimaryButton.disabled.color};
            background-color: ${theme.PrimaryButton.disabled.backgroundColor};
            pointer-events: none;
          `
        : css`
            color: ${theme.PrimaryButton.default.color};
            background-color: ${theme.PrimaryButton.default.backgroundColor};
          `};

    &:active {
      transform: scale(0.9);
    }
  }
`;

type PrimaryButtonProps = {
  className?: string;
  id?: string;
  children: Node;
  onClick?: () => void;
  isDisabled?: boolean;
  'data-testid'?: string; // to pass data-testid via styled-components :(
};

const PrimaryButton = (props: PrimaryButtonProps) => {
  const { className, id, children, onClick, isDisabled = false } = props;
  return (
    <StyledButton
      $isDisabled={isDisabled}
      onClick={!isDisabled ? onClick : () => {}}
      className={className}
      id={id}
      data-testid={props['data-testid']}
    >
      {children}
    </StyledButton>
  );
};

export default PrimaryButton;
